module.exports = __webpack_public_path__ + "static/img/RWA1266_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RWA1266_1.png
// module id = XpO7
// module chunks = 0